// Moving category constants
// Note: These should match MOVING_CATEGORIES in backend/api/constants/requests.js

export const MOVING_CATEGORIES = {
  APARTMENT: 'הובלת דירה',
  SMALL: 'הובלה קטנה',
  OFFICE: 'הובלת משרדים',
  HEAVY_EQUIPMENT: 'הובלת ציוד כבד/מיוחד'
};

// Array of all moving category values (for validation/enum)
export const MOVING_CATEGORY_VALUES = Object.values(MOVING_CATEGORIES);

// Array of category options for form selection
export const MOVING_CATEGORY_OPTIONS = [
  { value: MOVING_CATEGORIES.APARTMENT, label: MOVING_CATEGORIES.APARTMENT },
  { value: MOVING_CATEGORIES.SMALL, label: MOVING_CATEGORIES.SMALL },
  { value: MOVING_CATEGORIES.OFFICE, label: MOVING_CATEGORIES.OFFICE },
  { value: MOVING_CATEGORIES.HEAVY_EQUIPMENT, label: MOVING_CATEGORIES.HEAVY_EQUIPMENT }
];

